/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import * as qs from 'query-string';
import gql from 'graphql-tag';
import { Button } from 'primereact/button';
import { useHistory, useLocation } from 'react-router-dom';
import apollo from '../services/apollo';
import { Loading } from '../components/Loading';
import { persistCredentialsSession } from '../services/auth/auth-storage';
import runAcessTokenChecker from '../services/auth/auth-scheduler';
import { RequiredUserActionType } from '../shared/Constants';

const VERIFY_USER_EMAIL = gql`
  mutation($userId: ID!) {
    verifyUserEmail(userId: $userId) {
      userId
      requiredUserAction {
        type
        accountId
      }
      tokens {
        token
        refreshToken
      }
    }
  }
`;

const verifyUserEmail = (userId) =>
  apollo
    .mutate({
      mutation: VERIFY_USER_EMAIL,
      variables: {
        userId,
      },
    })
    .then((res) => res.data.verifyUserEmail);

const EmailVerification = () => {
  const location = useLocation();
  const history = useHistory();

  const { userId } = qs.parse(location.search);

  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);

  const verifyEmail = async () => {
    try {
      const data = await verifyUserEmail(userId);

      const { tokens: { token, refreshToken} } = data;

      persistCredentialsSession(token, refreshToken);

      runAcessTokenChecker();

      if (data.requiredUserAction) {
        const { type: requiredUserActionType, accountId: accountToBuySubscriptionFor } = data.requiredUserAction;

        if (requiredUserActionType === RequiredUserActionType.BUY_SUBSCRIPTION_FOR_ACCOUNT) {
          history.push(`/accounts/${accountToBuySubscriptionFor}`);
        }
      } else {
        setSuccess(true);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    verifyEmail();
  }, []);

  if (loading) {
    return <Loading />;
  }

  if (success) {
    return (
      <div className="p-grid">
        <div className="p-col-12">
          <div className="brand-detailed-wrapper">
            <div className="p-grid">
              <div className="p-col-6 p-offset-3">
                <FormattedMessage
                  id="email_verification.success"
                  defaultMessage="Email verification has successfully completed. Press the button below to be redirected to the dashboard screen"
                  tagName="h3"
                />
              </div>
              <div className="p-col-6 p-offset-3">
                <FormattedMessage id="email_verification.to_dashboard" defaultMessage="To dashboard">
                  {(text) => (
                    <Button
                      type="button"
                      label={text}
                      className="p-button-secondary"
                      onClick={() => history.push('/')}
                    />
                  )}
                </FormattedMessage>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="p-grid">
      <div className="p-col-12">
        <div className="brand-detailed-wrapper">
          <div className="p-grid">
            <div className="p-col-6 p-offset-3">
              <FormattedMessage
                id="email_verification.failed"
                defaultMessage="Email verification has failed. Please contact the person who sent you the invitation."
                tagName="h3"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailVerification;
